import { useEffect } from "react";
import useGenericContentStore from "../store/genericContent.store";
import { AppLogger } from "../utils/AppLogger";

/*Hook that will trigger retry button if network error occurs */

const useRetryCommand = (command: any, retryFunction: any) => {
	const isRetryTriggered = useGenericContentStore((state: any) => state.isRetryTriggered);
	const setIsRetryTriggered = useGenericContentStore((state: any) => state.setIsRetryTriggered);
	const retryCommand = useGenericContentStore((state: any) => state.retryCommand);

	useEffect(() => {
		if (isRetryTriggered && retryCommand === command) {
			AppLogger.log("useRetryCommand: ", retryCommand);
			setIsRetryTriggered(false);
			retryFunction();
		}
	}, [isRetryTriggered]);
};

export default useRetryCommand;
